import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons' 

function Facebook () {
 
    return (
      <a href="https://www.facebook.com/mo.arab.96" target="_blank" rel='noreferrer'>
        <FontAwesomeIcon icon={faFacebookF} />
      </a>
    );
  }

export default Facebook;
